import { useContext } from "react";
import ApiContext from "api";

export function useConsigazApi() {
  const { ConsigazApi } = useContext(ApiContext);
  if (!ConsigazApi) {
    throw new Error("useConsigazApi precisa de um ApiProvider acima");
  }
  return ConsigazApi;
}
